/**
 * paragraphs.ts — split server copy into the paragraphs its author wrote.
 *
 * Owner repo: @thegpservice/gpsclinics-portal.
 *
 * clinic-service joins separate statements with a BLANK LINE (`\n\n`) — the q14
 * weight declaration's two "I understand" acknowledgements are the live case —
 * and a single `<p>` collapses that whitespace, so two statements the patient is
 * meant to read one at a time ran together as one (CTO, 2026-09-24). The same
 * convention carries the "Why we ask" text (question set v6).
 *
 * A blank line is the ONLY separator: a single line break inside a paragraph is
 * left alone, exactly as HTML would treat it, so nothing the server did not mean
 * as a break becomes one. Whitespace-only paragraphs are dropped — an empty `<p>`
 * is a gap on screen and a blank stop for a screen reader.
 */
const PARAGRAPH_BREAK = /\n[^\S\n]*\n/;

/** True when the text holds at least one blank line — i.e. more than one paragraph was written. */
export function hasParagraphBreak(text: string | null | undefined): boolean {
  return Boolean(text) && PARAGRAPH_BREAK.test(text as string);
}

export function textParagraphs(text: string | null | undefined): string[] {
  if (!text) return [];
  return text
    .split(PARAGRAPH_BREAK)
    .map((paragraph) => paragraph.trim())
    .filter((paragraph) => paragraph.length > 0);
}
